import { t } from "@/i18n-js/instance";
import { toLocaleString } from "@circle-react/helpers/number";
import { AccessRegistryCard } from "../Card";
import type { BadgeProps } from "./Badge";
import { Badge } from "./Badge";
import { i18nRoot } from "./constants";

export interface CardProps {
  actions?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  membersCount?: number;
  showAs?: BadgeProps["variant"];
  spacesCount?: number;
  title: string;
  tooltip?: string;
}

export const Card = ({
  className,
  title,
  showAs,
  tooltip,
  actions,
  membersCount = 0,
  spacesCount = 0,
  children,
}: CardProps) => {
  const highlights = {
    members_count: t([i18nRoot, "highlights", "members_count"], {
      count: toLocaleString(membersCount),
    }),
    spaces_count: t([i18nRoot, "highlights", "spaces_count"], {
      count: toLocaleString(spacesCount),
    }),
  };

  return (
    <AccessRegistryCard
      className={className}
      title={title}
      titleColor={
        showAs === "removed" || showAs === "syncing"
          ? "text-disabled"
          : undefined
      }
      titleDecor={showAs ? <Badge variant={showAs} /> : null}
      tooltip={tooltip}
      actions={actions}
      highlights={highlights}
    >
      {children}
    </AccessRegistryCard>
  );
};
